import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { getApplicationSpaBackendUrl } from "@utils";
import { httpHeaders } from "@shared/constants/httpHeaders";
import { type TMagicLinkPurpose } from "@shared/types/magicLink.types";

interface IValidateMiddleServiceMagicLinkResponse {
  isValid: boolean;
}

interface IResendMeetingPrepLinkResponse {
  isSent: boolean;
}

export const middleServiceMagicLink = "middleServiceMagicLink";
export const middleServiceMagicLinkApi = createApi({
  reducerPath: middleServiceMagicLink,
  baseQuery: fetchBaseQuery({ baseUrl: getApplicationSpaBackendUrl() }),
  endpoints: (builder) => ({
    getMiddleServiceMagicLinkValidity: builder.query<
      IValidateMiddleServiceMagicLinkResponse,
      { token: string; purpose: TMagicLinkPurpose }
    >({
      query: ({ token, purpose }) => ({
        url: `/magic-link/validate?purpose=${purpose}`,
        headers: { [httpHeaders.magicToken]: token },
      }),
    }),
    resendMeetingPrepLink: builder.mutation<
      IResendMeetingPrepLinkResponse,
      { token: string; pageUrl: string; email: string }
    >({
      query: ({ token, pageUrl, email }) => ({
        url: "/meeting-prep-link/resend",
        method: "POST",
        headers: { [httpHeaders.magicToken]: token },
        body: { pageUrl, email },
      }),
    }),
  }),
});

export const { useGetMiddleServiceMagicLinkValidityQuery, useResendMeetingPrepLinkMutation } =
  middleServiceMagicLinkApi;
